
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"7.692","fill":"#E6FAEE"}}),_c('path',{attrs:{"d":"M12.106 30.695H27.57a.43.43 0 00.43-.428V9.733a.43.43 0 00-.43-.428H16.724v4.599a.43.43 0 01-.43.428h-4.618v15.935a.43.43 0 00.43.428zm10-13.488a.43.43 0 010 .607l-3.926 3.91a.44.44 0 01-.305.124.449.449 0 01-.305-.124.43.43 0 010-.607l3.926-3.91a.434.434 0 01.61 0zm.047 4.564a1.323 1.323 0 01-1.869 0 1.311 1.311 0 010-1.86c.5-.497 1.371-.497 1.874 0a1.317 1.317 0 01-.005 1.86zm-4.63-4.611a1.33 1.33 0 011.868-.005 1.319 1.319 0 01-.936 2.25 1.33 1.33 0 01-.937-.385 1.317 1.317 0 01.005-1.86zm-3.188 6.797h11.006a.43.43 0 01.43.428.43.43 0 01-.43.428H14.335a.43.43 0 01-.43-.428.43.43 0 01.43-.428zm0 2.653h11.006a.427.427 0 110 .856H14.335a.427.427 0 110-.856z","fill":"#27AE60"}}),_c('path',{attrs:{"d":"M15.864 9.553l-3.939 3.923h3.94V9.553zM18.781 18.413a.441.441 0 00.138-.325.442.442 0 00-.138-.325.46.46 0 00-.653 0c-.18.18-.18.47 0 .65a.47.47 0 00.653 0zM21.221 20.38a.445.445 0 00-.326.138.442.442 0 00-.138.325c0 .124.048.24.138.325.18.18.472.18.653 0 .18-.18.18-.47 0-.65a.446.446 0 00-.327-.137z","fill":"#27AE60"}})])
          )
        }
      }
    